import { useState } from "react";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import styles from "./Header.module.css";
import { Link } from "react-router-dom";
import { megaMenu } from "../../data/navigation";
import HeaderDropdown from "../HeaderDropdown/HeaderDropdown";
import useScrollPosition from "../../hooks/useScrollPosition";
import useDetectKeelMind from "../../hooks/useDetectKeelMind";
import { useEffect } from "react";
import HamburgerButton from "../HamburgerButton/HamburgerButton";
import useKeelLogoSwitch from "../../hooks/useKeelLogoSwitch";
import MindPageLink from "../MindPageLink/MindPageLink";
import MegaMenuPanel from "../MegaMenuPanel/MegaMenuPanel";

function Header({
    dark = false,
    showSignIn = false,
    backgroundScrollThreshold = 50,
}) {
    const [showMenu, setShowMenu] = useState(false);
    const scrollPositon = useScrollPosition();
    const isKeelMind = useDetectKeelMind();
    const [backgroundState, setBackgroundState] = useState(false);
    const [hoverState, setHoverState] = useState(false);
    const [megaMenuState, setMegaMenuState] = useState(0);

    const { logoSrc, logoHref } = useKeelLogoSwitch(dark, backgroundState);

    useEffect(() => {
        if (
            (scrollPositon >= backgroundScrollThreshold && !backgroundState) ||
            hoverState
        ) {
            setBackgroundState(true);
        } else if (
            scrollPositon < backgroundScrollThreshold &&
            backgroundState
        ) {
            setBackgroundState(false);
        }
    }, [scrollPositon, backgroundState, backgroundScrollThreshold, hoverState]);

    function handleOpenClick() {
        setShowMenu(true);
    }

    function handleHeaderHover(state) {
        setHoverState(state);
    }

    function handleNavButtonClick(index) {
        setMegaMenuState((prevState) => {
            if (prevState === index) {
                // toggle menu if current panel open
                setShowMenu((prevShow) => !prevShow);
                return prevState;
            } else {
                setShowMenu(true);
                return index;
            }
        });
    }

    return (
        <header
            id={styles.header}
            className={[
                backgroundState ? styles.background : "",
                showMenu ? styles.open : "",
            ].join(" ")}
            onMouseEnter={() => handleHeaderHover(true)}
            onMouseLeave={() => handleHeaderHover(false)}
        >
            <MegaMenuPanel
                showMenu={showMenu}
                setShowMenu={setShowMenu}
                megaMenuState={megaMenuState}
            />
            <HamburgerMenu
                showMenu={showMenu}
                setShowMenu={setShowMenu}
                showSignIn={showSignIn || isKeelMind}
            />
            <div id={styles.left}>
                <MindPageLink
                    href={logoHref}
                    aria-label="Link to home page"
                    id={styles.keel_logo}
                >
                    <img
                        src={logoSrc}
                        style={{ height: "100%" }}
                        alt="Keel logo"
                    />
                </MindPageLink>
            </div>
            <nav id={styles.middle}>
                {megaMenu.map((link, index) => {
                    if (
                        !link.hamburgerOnly &&
                        !(
                            window.location.hostname.includes("keelmind.com") &&
                            link.hideOnMind
                        ) &&
                        !(
                            window.location.hostname.includes("keel.digital") &&
                            link.hideOnDigital
                        )
                    ) {
                        return (
                            <button
                                className={[
                                    styles.nav_button,
                                    dark && !backgroundState
                                        ? styles.dark_text
                                        : "",
                                ].join(" ")}
                                onClick={() => handleNavButtonClick(index)}
                                key={link.navName}
                            >
                                {link.navName}
                                <img
                                    className={styles.chevron}
                                    src={
                                        dark && !backgroundState
                                            ? "/images/chevron-down-blue.svg"
                                            : "/images/chevron-down-white.svg"
                                    }
                                    alt=""
                                />
                            </button>
                        );
                    } else {
                        return null;
                    }
                })}
            </nav>
            <div id={styles.right}>
                {(showSignIn || isKeelMind) && (
                    <HeaderDropdown
                        className={[
                            styles.header_button,
                            "outline-button",
                            dark && !backgroundState ? styles.dark_text : "",
                        ].join(" ")}
                        id={styles.sign_in}
                        text={"Sign In"}
                        data={[
                            {
                                href: "https://app.us.geta-head.com/app/gah/",
                                name: "United States",
                            },
                            {
                                href: "https://app.ca.geta-head.com/app/gah/",
                                name: "Canada",
                            },
                        ]}
                    />
                )}
                <Link
                    id={styles.contact_us}
                    className={[styles.header_button, "orange-button"].join(
                        " "
                    )}
                    to="/contact-us"
                >
                    Contact Us
                    <img src="/images/up-right-arrow.svg" alt="" />
                </Link>
                <HamburgerButton
                    dark={dark && !backgroundState}
                    id={styles.hamburger_button}
                    onClick={handleOpenClick}
                />
            </div>
        </header>
    );
}

export default Header;
